/* Material */
import Alert from '@mui/material/Alert'
import useStyles from './styles'

/* Material-Icons */
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

interface Props {
  deliverytime?: number
  stock?: number
  onlyStock?: true
  inquireOnly?: true
}

/* Config */
import config from 'src/config'
import { useProductInquiryConfig } from 'src/context/ProductInquiryContext'

const DeliverytimeDisplay: React.FC<Props> = ({
  deliverytime,
  stock = 0,
  onlyStock,
  inquireOnly,
}) => {
  const classes = useStyles()
  const productInquiry = useProductInquiryConfig()
  const displayClassName = (...classNames: string[]) =>
    classNames.filter(Boolean).join(' ')

  if (inquireOnly) {
    return <Alert
      className={displayClassName(classes.deliverytimeDisplay, classes.deliverytimeInfo)}
      severity='info'
    >
      {productInquiry.availabilityLabel}
    </Alert>
  }

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Artikel nur noch Lagerware */
  if (onlyStock && stock <= 0)
    return <Alert
        className={displayClassName(classes.deliverytimeDisplay, classes.deliverytimeWarning)}
        severity="warning"
        icon={<ErrorOutlineIcon />}
      >
        aktuell nicht lieferbar
      </Alert>

  if (onlyStock && stock <= config.onlyStockWarningLimit)
    return <Alert 
        className={displayClassName(classes.deliverytimeDisplay, classes.deliverytimeWarning)}
        severity="warning" 
        icon={<ErrorOutlineIcon />}
      >
        nur noch {stock} x lieferbar
      </Alert>

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Artikel Bestellbar und auf Lager */
  if (stock)
    return <Alert 
        className={displayClassName(classes.deliverytimeDisplay, classes.deliverytimeSuccess)}
        severity="success"
      >
        { stock <= config.stockFullQty && <>
          {stock} x {' '}
        </>}
        sofort lieferbar
      </Alert>

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  /* Ganz normale Lieferzeit */
  return <Alert 
      className={displayClassName(classes.deliverytimeDisplay, classes.deliverytimeInfo)}
      severity="info" 
    >
      Lieferzeit: {deliverytime} Werktage*²
    </Alert>

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  
}

export default DeliverytimeDisplay
